import React, { useState, useEffect } from "react";
import CustomFieldModal from "./CustomFieldModal";
import useCustomField from "../../../../../hooks/useCustomField/UseCustomField";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import EditCustomFieldModal from "./EditCustomFieldModal";
import useUpdateCustomField from "../../../../../hooks/useCustomField/useUpdateCustomField";
import useEditCustomField from "../../../../../hooks/useCustomField/useEditCustomField";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import FieldEditModal from "./FieldEditModal/FieldEditModal";

const GeoDetails = ({
  dynamicFields = [],
  hidden,
  onFieldChange, // Accept onFieldChange prop from parent
  require,
  data,
  setData,
  Message,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [fieldToDelete, setFieldToDelete] = useState(null);
  const [division, setDivision] = useState("");
  const [message, setMessage] = useState({ type: "", text: "" });

  // Location states
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  const { submitCustomField } = useCustomField();
  const { updateCustomField } = useUpdateCustomField();
  const apiUrls = process.env.REACT_APP_API_URLS;

  const {
    showEditModal,
    selectedField,
    handleOpenEditModal,
    handleCloseEditModal,
    handleSubmitUpdateField,
  } = useEditCustomField();

  // Fetch countries on component mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(
          "https://locationapi.jpworld.cloud/api/countries/"
          // "https://slhp1xk9-8000.inc1.devtunnels.ms/api/countries/"
        );
        // console.log("API Response:", response.data); // Debug the response
        // If the response is an object, extract the array
        const countriesArray = Array.isArray(response.data)
          ? response.data
          : response.data.data;
        setCountries(countriesArray || []); // Ensure it's an array
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
    fetchCountries();
  }, []);

  // Fetch states when a country is selected
  useEffect(() => {
    if (selectedCountry) {
      const fetchStates = async () => {
        try {
          const response = await axios.get(
            // `https://locationapi.jpworld.cloud/api/states/${selectedCountry}/`
            `https://slhp1xk9-8000.inc1.devtunnels.ms/api/states/${selectedCountry}/`
          );
          console.log("States Response:", response.data); // Debug the response
          const statesArray = Array.isArray(response.data)
            ? response.data
            : response.data.data;
          setStates(statesArray || []); // Ensure it's an array
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      };
      fetchStates();
    }
  }, [selectedCountry]);

  // Fetch cities when a state is selected
  useEffect(() => {
    if (selectedState) {
      const fetchCities = async () => {
        try {
          const response = await axios.get(
            // `https://locationapi.jpworld.cloud/api/cities/${selectedState}/`
            `https://slhp1xk9-8000.inc1.devtunnels.ms/api/cities/${selectedState}/`
          );
          console.log("Cities Response:", response.data); // Debug the response
          const citiesArray = Array.isArray(response.data)
            ? response.data
            : response.data.data;
          setCities(citiesArray || []); // Ensure it's an array
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      };
      fetchCities();
    }
  }, [selectedState]);

  // Handle form submission for adding a new field
  const handleSubmit = async (data) => {
    const result = await submitCustomField(data);
    if (result.success) {
      toast.success("Field is Added Succefully", {
        position: "top-right",
        autoClose: 600,
      });

      setShowModal(false);
      setTimeout(() => {
        window.location.reload();
      }, 700); // Reload the page on success
    } else {
      toast.error(result.message, {
        position: "top-right",
        autoClose: 1000,
      });
      setShowModal(false);
    }
  };

  // Open Add Field Modal
  const handleOpenModal = () => {
    setDivision("Geo Details");
    setShowModal(true);
  };

  // Open Delete Confirmation Modal
  const handleDeleteField = (field) => {
    setFieldToDelete(field);
    setShowDeleteModal(true);
  };

  // Confirm deletion of the field
  const handleConfirmDelete = async () => {
    if (fieldToDelete) {
      try {
        const response = await axios.delete(
          `${apiUrls}/buyer_settings/custom-fields/${fieldToDelete.id}/`
        );

        if (response.status === 204 || response.status === 200) {
          setMessage({ type: "success", text: "Field deleted successfully!" });
          window.location.reload(); // Reload the page on success
        } else {
          setMessage({ type: "error", text: "Failed to delete the field." });
        }
      } catch (error) {
        setMessage({
          type: "error",
          text: "An error occurred while deleting the field.",
        });
      } finally {
        setShowDeleteModal(false);
        setFieldToDelete(null);
      }
    }
  };

  // Close Delete Confirmation Modal
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setFieldToDelete(null);
  };

  // Handle input changes for location fields
  const handleLocationChange = (e, type) => {
    const value = e.target.value;
    switch (type) {
      case "country":
        setSelectedCountry(value);
        setSelectedState(""); // Reset state and city when country changes
        setSelectedCity("");
        onFieldChange("country", value); // Notify parent of changes
        break;
      case "state":
        setSelectedState(value);
        setSelectedCity(""); // Reset city when state changes
        onFieldChange("state", value); // Notify parent of changes
        break;
      case "city":
        setSelectedCity(value);
        onFieldChange("city", value); // Notify parent of changes
        break;
      default:
        break;
    }
  };

  // Handle input changes for other fields
  const handleInputChange = (e, field) => {
    const { value } = e.target;
    // Update the specific field in the data object
    setData((prevData) => ({
      ...prevData,
      [field.column_name]: value,
    }));
    onFieldChange(field.column_name || field.name, value); // Notify parent of changes
  };

       const [isEditModalOpen, setEditModalOpen] = useState(false)
  const [formData, setFormData] = useState({
    label: '',
    placeholder: '',
    type: 'required',
  });

  const handleSave = () => {
    console.log("Form Data Saved:", formData);
    setEditModalOpen(false);
  };

  return (
    <>
      <div className="border-2 border-gray-200 shadow-lg rounded-md p-6 mt-8">
        <h2 className="text-lg font-semibold mb-4">
          <span className="underline">Geo Details :</span>
        </h2>

        {/* Display success/error messages */}
        {/* {message.text && (
          <div
            className={`p-2 mb-4 rounded-md ${
              message.field_type === "success"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {message.text}
          </div>
        )} */}

        {/* Static Fields */}
        <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Country Dropdown */}
          <div>
            <div className="flex items-center justify-between">
            <label className="block">
              Country<span className="text-red-500">*</span>
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Countrty",placeholder:"Select Your Country"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <select
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
              value={selectedCountry}
              onChange={(e) => handleLocationChange(e, "country")}
              disabled={require}
              readOnly={require}
            >
              <option disabled value="">
                Select your Country
              </option>
              {countries.map((country) => (
                <option key={country.country_id} value={country.country_id}>
                  {country.country_name}
                </option>
              ))}
            </select>
          </div>

          {/* State Dropdown */}
          {/* {selectedCountry && ( */}
          <div>
            <div className="flex items-center justify-between">
            <label className="block">
              State<span className="text-red-500">*</span>
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"State",placeholder:"Select your state"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <select
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
              value={selectedState}
              onChange={(e) => handleLocationChange(e, "state")}
              disabled={require}
              readOnly={require}
            >
              <option disabled value="">
                Select your State
              </option>
              {states.map((state) => (
                <option key={state.state_id} value={state.state_id}>
                  {state.state_name}
                </option>
              ))}
            </select>
          </div>
          {/* )} */}

          {/* City Dropdown */}
          {/* {selectedState && ( */}
          <div>
            <div className="flex items-center justify-between">
            <label className="block">
              City<span className="text-red-500">*</span>
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"City",placeholder:"Select your city"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <select
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
              value={selectedCity}
              onChange={(e) => handleLocationChange(e, "city")}
              disabled={require}
              readOnly={require}
            >
              <option disabled value="">
                Select your City
              </option>
              {cities.map((city) => (
                <option key={city.id} value={city.id}>
                  {city.name}
                </option>
              ))}
            </select>
          </div>
          {/* )} */}

          {/* Other Static Fields */}
          {[
            {
              label: "Locality",
              placeholder: "Enter your Locality",
              type: "text",
              name: "locality",
            },
            {
              label: "Street",
              placeholder: "Enter your Street",
              type: "text",
              name: "street",
            },
            {
              label: "Pin Code",
              placeholder: "Enter your Pin Code",
              type: "text",
              name: "pincode",
            },
          ].map(({ label, placeholder, type, name }) => (
            <div key={name}>
              <div className="flex items-center justify-between">
              <label className="block">
                {label}
                <span className="text-red-500">*</span>
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label,placeholder});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <input
                type={type}
                name={name} // Add a name for the field
                placeholder={placeholder}
                className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
                onChange={(e) => handleInputChange(e, { name })} // Notify parent of changes
                disabled={require}
                readOnly={require}
              />
            </div>
          ))}

          {/* Dynamic Fields Rendering */}
          {dynamicFields.length > 0 &&
            dynamicFields
              .filter((field) => field) // Filter out undefined or null fields
              .map(
                (field) =>
                  field.division == "Geo Details" && (
                    <div key={field.column_name || Math.random()}>
                      <div className="flex justify-between">
                        <label className="block">
                          {field.field_label?.replace(/_/g, " ") ||
                            "Unnamed Field"}
                          {field.is_required && (
                            <span className="text-red-500">*</span>
                          )}
                        </label>
                        <div
                          className={`gap-[5px] ${hidden ? "hidden" : "flex"}`}
                        >
                          <button
                            className="color-[#979797]"
                            type="button"
                            onClick={() => handleOpenEditModal(field)}
                          >
                            <MdOutlineEdit className="color-[#979797]" />
                          </button>
                          <button
                            className="color-[#979797]"
                            type="button"
                            onClick={() => handleDeleteField(field)}
                          >
                            <MdDeleteOutline className="color-[#979797]" />
                          </button>
                        </div>
                      </div>

                      {/* Render Dynamic Input Types */}
                      {field.field_type === "text" ||
                      field.field_type === "date" ? (
                        <input
                          type={field.field_type}
                          name={field.column_name} // Use column_name as the field name
                          placeholder={field.placeholder || ""}
                          className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
                          onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                        />
                      ) : field.field_type === "radio" ||
                        field.field_type === "checkbox" ? (
                        (field.options?.split(",") || []).map((option) => (
                          <div
                            key={option}
                            className="flex items-center space-x-2 mt-1"
                          >
                            <input
                              type={field.field_type}
                              id={option}
                              name={field.column_name}
                              value={option}
                              onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                            />
                            <label htmlFor={option}>{option}</label>
                          </div>
                        ))
                      ) : field.field_type === "dropdown" ? (
                        <select
                          name={field.column_name} // Use column_name as the field name
                          className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none"
                          onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                        >
                          <option disabled>
                            Select {field.column_name || "Field"}
                          </option>
                          {(field.options?.split(",") || []).map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      ) : null}
                    </div>
                  )
              )}
        </form>

        {/* Add Field Button */}
        <div className='grid grid-cols-2 items-center px-10 mt-6'>
          <div className='flex items-center justify-end'>
            <button
              onClick={handleOpenModal}
              className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
            >
              Add Field
            </button>
          </div>
          <div className='flex items-center justify-end'>
            <button
              onClick={handleOpenModal}
              className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
            >
              Add Field
            </button>
          </div>
        </div>
      </div>

      <FieldEditModal
        isOpen={isEditModalOpen}
        onClose={() => setEditModalOpen(false)}
        onSave={handleSave}
        formData={formData}
        setFormData={setFormData}
        content={"Geo Details"}
      />

      {/* Add Custom Field Modal */}
      <CustomFieldModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleSubmit}
        division={division}
      />

      {/* Edit Custom Field Modal */}
      <EditCustomFieldModal
        isOpen={showEditModal}
        onClose={handleCloseEditModal}
        onSubmit={handleSubmitUpdateField}
        fieldData={selectedField}
      />

      {/* Delete Confirmation Modal */}
      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDelete}
      />
      <ToastContainer />
    </>
  );
};

export default GeoDetails;
